import { JOURNEY_ID_PARAM } from '../constants/journey.constants';

import { createJourneyId } from './create-journey-id';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isJourneyId = (value: string | null | undefined): value is string => typeof value === 'string' && UUID_PATTERN.test(value);

export const resolveJourneyId = (search: string): string => {
  const journeyId = new URLSearchParams(search).get(JOURNEY_ID_PARAM);
  if (isJourneyId(journeyId)) return journeyId.toLowerCase();

  return createJourneyId();
};
